module.exports = __webpack_public_path__ + "img/search-active.08c70ad4.png";